<div class="bank-accounts">
  @for (bankAccount of bankAccounts(); track bankAccount) {
    <div class="bank-account">
      <div class="left">
        <mat-icon class="icon account-icon">account_balance</mat-icon>
        <div>
          <div>
            <span>{{ bankAccount.bankName }}</span>
            <glxy-badge size="small" color="light-grey" class="currency-badge">
              {{ bankAccount.currency | uppercase }}
            </glxy-badge>
          </div>
          <span>***** {{ bankAccount.last4 }}</span>
        </div>
      </div>
      <div>
        <glxy-badge class="default-badge" color="blue" *ngIf="bankAccount.defaultForCurrency">
          {{ 'BANK_ACCOUNT.DEFAULT' | translate }}
        </glxy-badge>
        <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="loadingStates()[bankAccount.id] || false">
          <glxy-button-loading-indicator [isLoading]="loadingStates()[bankAccount.id] || false">
            <mat-icon>more_vert</mat-icon>
          </glxy-button-loading-indicator>
        </button>
        <mat-menu #menu="matMenu">
          <button [disabled]="bankAccount.defaultForCurrency" mat-menu-item (click)="setDefault(bankAccount.id)">
            <span>{{ 'BANK_ACCOUNT.SET_DEFAULT' | translate }}</span>
          </button>
          <button [disabled]="bankAccount.defaultForCurrency" mat-menu-item (click)="delete(bankAccount.id)">
            <span>{{ 'BANK_ACCOUNT.REMOVE' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  }
</div>
